/**
 * BeautyAssistantSessionProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import BeautyAssistantSessionContext from './beauty-assistant-sessions-context'
import { fetchBeautyAssistantSession, fetchBeautyAssistantSessionBySlugName } from './beauty-assistant-sessions-api'

export default function BeautyAssistantSessionProvider({ children }) {
  const state = {
    fetchBeautyAssistantSession,
    fetchBeautyAssistantSessionBySlugName
  }
  return (
    <BeautyAssistantSessionContext.Provider value={state}>
      {children}
    </BeautyAssistantSessionContext.Provider>
  )
}
